import { Link } from 'react-router-dom';
import scrollToSection from '../../utils/scrollToSection';
import i18n from '../../i18n';
import { buildLocalizedPath } from '../../utils/languageUrl';

export default function Logo({ className, isInDrawer = false }) {
  return (
    <Link
      className={className}
      to={buildLocalizedPath('/', i18n.language)}
      onClick={() => scrollToSection('home')}
    >
      <img
        src="/logo.svg"
        alt="Feller by Schneider Electric"
        className={isInDrawer ? 'offcanvas-logo' : 'logo'}
      />
    </Link>
  );
}
